module.exports = __webpack_public_path__ + "img/dashboard.eb72123d.svg";